'use strict';

import { Form } from '@lf/mwuikit/src/scripts/objects/form';
import { generateRecaptcha } from '../../api/reCaptchaForm';

(function () {
    const formElement = document.getElementById('basic-form');

    if (formElement) {
        const form = Form({ element: formElement, useDefaultSubmit: true });
        generateRecaptcha(formElement, () => formElement.submit());

        const corporateNameInputWrapperElement = document.getElementById('corporateNameInputWrapper');

        if (corporateNameInputWrapperElement) {
            const moralPersonButton = document.getElementById("mp");
            if (moralPersonButton) {
                moralPersonButton.addEventListener('change', function() {
                    corporateNameInputWrapperElement.style.display = '';
                });
            }

            const physicalPersonButton = document.getElementById('pp');
            if (physicalPersonButton) {
                physicalPersonButton.addEventListener('change', function () {
                    corporateNameInputWrapperElement.style.display = 'none';
                });
            }
        }
    }
}());
